import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    gap: 20px;
    height: 210px;
    overflow: auto;
    overflow-y: hidden;
    padding: 5px;
    width: 100%;
    &::-webkit-scrollbar {
        height : 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    @media (min-width: 720px) {
        height: 210px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 210px;
    }
`;

export const ContainerDay = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
`;

export const DayButton = styled.button`
    background: ${(props)=>(props.$active ? props.$background : 'transparent')};
    border: none;
    border-radius: 5px;
    color: ${(props)=>(props.$active ? '#fff' : '#333')};
    cursor: pointer;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    outline: none;
    padding: 2px;
    text-align: center;
    transition: 1s;
    width: 20px;
    &:disabled{
        color: #C7C7C7;
        cursor: auto;
    }
    @media (min-width: 720px) {
        font-size: 18px;
        padding: 2.5px;
        width: 25px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 10px;
        padding: 2.5px;
        width: 20px;
    }
`;

export const DayStatus = styled.div`
    align-items: flex-end;
    background: #C7C7C7;
    border-radius: 10px;
    display: flex;
    flex-direction: column-reverse;
    height: 200px;
    overflow: hidden;
    width: 14px;
`;

export const Greenfill = styled.div`
    background: #33CC99;
    height: ${props => (props.$altura)}%;
    width: 100%;
`;

export const Yellowfill = styled.div`
    background: #EABC1A;
    height: ${props => (props.$altura)}%;
    width: 100%;
`;

export const Redfill = styled.div`
    background: #FF3939;
    height: ${props => (props.$altura)}%;
    width: 100%;
`;

export const Purplefill = styled.div`
    background: #6600CC;
    height: ${props => (props.$altura)}%;
    width: 100%;
`;

export const ContainerGraph = styled.div`
    display: flex;
    flex-direction: column;
    height: 200px;
    width: auto;
    @media (min-width: 720px) {
        height: 220px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 200px;
    }
    @media (min-width: 1700px) {
        width: 100%;
    }
`;

export const ContainerDays = styled.div`
    display: flex;
    gap: 5px;
    justify-content: space-between;
    padding: 5px 10px 5px 30px;
    width: 100%;
    @media (min-width: 720px) {
        gap: 12px;
        padding: 2px 8px 2px 28px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        gap: 13px;
        padding: 5px 10px 5px 30px;
    }
    
`;